import React from 'react';
import { BASE_API } from '../../api/Globals';
import { useFormReAssignment } from '../../hooks/useFormReAssignment';
import SelectListValidators from '../sturtural/SelectListValidators';
import Loader from '../sturtural/Loader';
import MessageDetail from '../sturtural/MessageDetail';

const UserFormReAssignment = ({ solicitudid, handleHidden }) => {

    const initialForm = {
        validador: ""
    }

    const validationsFrom = (form) => {
        let errors = {};
       
        if(!form.validador > 0) {
            errors.validador = "Es obligatorio elegir un (validador).";
        }
    
        return errors;
    }

    const {form,
        errors,
        loading,
        response,
        handleChange,
        handleBlur,
        handleSubmit} = useFormReAssignment(initialForm, validationsFrom, handleHidden, solicitudid);

    return (
        <form onSubmit={handleSubmit}>
            <div className="mb-3">
                <SelectListValidators title="validador" url={`${BASE_API}demand/validators`} value={form.validador} style={errors.validador && 'p-invalid'}  handleChange={handleChange} handleBlur={handleBlur} />
                {errors.validador && <small className="p-error">{errors.validador}</small>}
                <div id="validatorsHelp" className="form-text">Por favor seleccione un validador para reasignarle esta solicitud.</div>
            </div>
            {loading && <Loader />}
            {response && <MessageDetail mensaje="La reasignacion se realizo correctamente" />}
            <button type="submit" className="btn btn-primary">Reasignar</button>
        </form>
    );
};

export default UserFormReAssignment;